@if (!lines.length) {
  <div class="alert alert-warning text-center">
    {{ "ENQUIRIES.AIRLINES_QUOTING.NO_AIRLINE_ADDED" | translate }}<br />
    <br />
    @if (enquiry) {
      <a
        [routerLink]="'/admin/enquiries/' + enquiry.id + '/select-airlines'"
        class="btn btn-primary mb-1"
        [class.disabled]="enquiry.status === EnumEnquiryStatus.confirmed"
        >
        <fa-icon [icon]="faPlus"></fa-icon>
        {{ "ENQUIRIES.ADD_AIRLINES" | translate }}
      </a>
    }
  </div>
}

@if (lines.length) {
  <div class="card mb-4">
    <div class="card-header d-flex flex-column flex-md-row gap-2 justify-content-center">
      @if (hasAclAccess(EnumAcl.enquiriesSelectAirlines)) {
        <a
          [routerLink]="'/admin/enquiries/' + enquiry.id + '/select-airlines'"
          class="btn btn-primary btn-sm"
          [class.disabled]="enquiry.status === EnumEnquiryStatus.confirmed"
          >
          <fa-icon [icon]="faPlus"></fa-icon>
          {{ "ENQUIRIES.ADD_AIRLINES" | translate }}</a
          >
        }
        @if (
          hasAclAccess(EnumAcl.enquirieSendMessageToAirlines) &&
          ![EnumEnquiryType.business, EnumEnquiryType.helico].includes(enquiry.type)
          ) {
          <a
            [routerLink]="'/admin/enquiries/' + enquiry.id + '/send-message-to-airlines'"
            class="btn btn-primary btn-sm"
            [class.disabled]="enquiry.status === EnumEnquiryStatus.confirmed"
            >
            <fa-icon [icon]="faPaperPlane"></fa-icon>
            {{ "ENQUIRIES.CONTACT_AIRLINES" | translate }}</a
            >
          }
          @if (
            hasAclAccess(EnumAcl.enquiriesRelanceAirline) &&
            ![EnumEnquiryType.business, EnumEnquiryType.helico].includes(enquiry.type)
            ) {
            <a
              [routerLink]="'/admin/enquiries/' + enquiry.id + '/relance-airline'"
              class="btn btn-primary btn-sm"
              [class.disabled]="enquiry.status === EnumEnquiryStatus.confirmed"
              >
              <fa-icon [icon]="faBell"></fa-icon>
              {{ "ENQUIRIES.REMIND_AIRLINES" | translate }}</a
              >
            }
            @if (
              hasAclAccess(EnumAcl.enquiriesCancelledEmailToAirline) &&
              ![EnumEnquiryType.business, EnumEnquiryType.helico].includes(enquiry.type)
              ) {
              <a
                [routerLink]="'/admin/enquiries/' + enquiry.id + '/cancel-email-airline'"
                class="btn btn-primary btn-sm"
            [class.disabled]="
                ![EnumEnquiryStatus.confirmed, EnumEnquiryStatus.cancelled].includes(enquiry.status)
            "
                >
                <fa-icon [icon]="faCancel"></fa-icon>
                {{ "ENQUIRIES.CANCELLATION_EMAIL_FOR_AIRLINES" | translate }}</a
                >
              }
            </div>
            <div class="table-responsive no-border main-table">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th></th>
                    @for (field of fields; track field.code) {
                      <th
                        scope="col"
                        class="sortable text-center"
                        [class.is-sorted]="orderBy.field == field.code"
                        [class.asc]="orderBy.field == field.code && orderBy.direction == 'asc'"
                        [class.desc]="orderBy.field == field.code && orderBy.direction == 'desc'"
                        (click)="sortField(field.code)"
                        [innerText]="field.title | translate"
                      ></th>
                    }
                  </tr>
                </thead>
                <tbody>
                  @for (line of lines; track line.cotationId ?? line.offerId) {
                    <tr
                      [class.table-success]="line.status === EnumEnquiryCotationStatus.confirmed"
                      >
                      <td class="text-start">
                        <div class="btn-group">
                          @if (isLogged && hasAclAccess(EnumAcl.quotationsList)) {
                            <a
                              class="btn btn-primary btn-sm"
                                [routerLink]="[
                                    '/admin/quotations/add/' + enquiry.id,
                                    line.offerId,
                                    line.cotationId ? line.cotationId : ''
                                ]"
                                [appTooltip]="
                                    'ENQUIRIES.AIRLINES_QUOTING.CREATE_QUOTATION' | translate
                                "
                              data-bs-placement="left"
                              >
                              <fa-icon [icon]="faFileContract"></fa-icon>
                            </a>
                          }
                          @if (
                            line.status === EnumEnquiryCotationStatus.answered &&
                            hasAclAccess(EnumAcl.enquirieSendMessageToAirlines)
                            ) {
                            <a
                              class="btn btn-primary btn-sm"
                                [routerLink]="
                                    '/admin/enquiries/' +
                                    enquiry.id +
                                    '/send-message-to-airlines/' +
                                    line.airlineId +
                                    '/blank-email'
                                "
                                [appTooltip]="
                                    'ENQUIRIES.AIRLINES_QUOTING.CONTACT_AIRLINE' | translate
                                "
                              data-bs-placement="left"
                              >
                              <fa-icon [icon]="faEnvelope"></fa-icon>
                            </a>
                          }
                          @if (
                            isLogged &&
                            ((enquiry.status !== EnumEnquiryStatus.confirmed &&
                            hasAclAccess(EnumAcl.enquiriesAddEditCotation)) ||
                            (enquiry.status === EnumEnquiryStatus.confirmed &&
                            hasAclAccess(
                            EnumAcl.enquiriesAddEditCotationForConfirmedEnquiry
                            )))
                            ) {
                            @if (
                              line.status === EnumEnquiryCotationStatus.toContact &&
                              enquiry.status !== EnumEnquiryStatus.confirmed &&
                              hasAclAccess(EnumAcl.enquirieSendMessageToAirlines) &&
                              ![
                              EnumEnquiryType.business,
                              EnumEnquiryType.helico
                              ].includes(enquiry.type)
                              ) {
                              <a
                                class="btn btn-primary btn-sm"
                                    [routerLink]="
                                        '/admin/enquiries/' +
                                        enquiry.id +
                                        '/send-message-to-airlines/' +
                                        line.airlineId
                                    "
                                    [appTooltip]="
                                        'ENQUIRIES.AIRLINES_QUOTING.CONTACT_AIRLINE' | translate
                                    "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faEnvelope"></fa-icon>
                              </a>
                            }
                            @if (
                              line.status ===
                              EnumEnquiryCotationStatus.waitingForAnswer &&
                              enquiry.status !== EnumEnquiryStatus.confirmed &&
                              hasAclAccess(EnumAcl.enquiriesRelanceAirline) &&
                              ![
                              EnumEnquiryType.business,
                              EnumEnquiryType.helico
                              ].includes(enquiry.type)
                              ) {
                              <a
                                class="btn btn-primary btn-sm"
                                    [routerLink]="
                                        '/admin/enquiries/' +
                                        enquiry.id +
                                        '/relance-airline/' +
                                        line.airlineId
                                    "
                                    [appTooltip]="
                                        (line.followedUp
                                            ? 'ENQUIRIES.AIRLINES_QUOTING.REMIND_AIRLINE_AGAIN'
                                            : 'ENQUIRIES.AIRLINES_QUOTING.REMIND_AIRLINE'
                                        ) | translate
                                    "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faEnvelope"></fa-icon>
                              </a>
                            }
                            @if (
                              line.status === EnumEnquiryCotationStatus.answered &&
                              [
                              EnumEnquiryStatus.confirmed,
                              EnumEnquiryStatus.cancelled
                              ].includes(enquiry.status) &&
                              hasAclAccess(EnumAcl.enquiriesCancelledEmailToAirline) &&
                              ![
                              EnumEnquiryType.business,
                              EnumEnquiryType.helico
                              ].includes(enquiry.type)
                              ) {
                              <a
                                class="btn btn-primary btn-sm"
                                    [routerLink]="
                                        '/admin/enquiries/' +
                                        enquiry.id +
                                        '/cancel-email-airline/' +
                                        line.airlineId
                                    "
                                    [appTooltip]="
                                        'ENQUIRIES.AIRLINES_QUOTING.SEND_CANCELLATION_EMAIL'
                                            | translate
                                    "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faEnvelope"></fa-icon>
                              </a>
                            }
                            @if (line.offerId && line.cotationId) {
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="editCotation(line.offerId, line.cotationId)"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.EDIT' | translate
                                        "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faEdit"></fa-icon>
                              </button>
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="addCotationToOffer(line.offerId)"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.DUPLICATE' | translate
                                        "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faPlus"></fa-icon>
                              </button>
                              @if (
                                hasAclAccess(
                                EnumAcl.enquiriesViewAttachedDocumentsToCotation
                                )
                                ) {
                                <button
                                  type="button"
                                  class="btn btn-primary btn-sm"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.DOCUMENTS_ATTACHED'
                                                | translate
                                        "
                                  (click)="viewAttachedDocumentsOfCotation(line.cotationId)"
                                  >
                                  <fa-icon [icon]="faPaperclip"></fa-icon>
                                </button>
                              }
                              <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                (click)="deleteCotation(line.cotationId)"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.DELETE' | translate
                                        "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faTrash"></fa-icon>
                              </button>
                            }
                            @if (line.offerId && !line.cotationId) {
                              <button
                                type="button"
                                class="btn btn-primary btn-sm"
                                (click)="addCotationToOffer(line.offerId)"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.EDIT' | translate
                                        "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faEdit"></fa-icon>
                              </button>
                              <button
                                type="button"
                                class="btn btn-danger btn-sm"
                                (click)="deleteOffer(line.offerId)"
                                        [appTooltip]="
                                            'ENQUIRIES.AIRLINES_QUOTING.DELETE' | translate
                                        "
                                data-bs-placement="left"
                                >
                                <fa-icon [icon]="faTrash"></fa-icon>
                              </button>
                            }
                          }
                        </div>
                      </td>
                      <td>
                        @if (
                          enquiry.status === EnumEnquiryStatus.confirmed ||
                          !hasAclAccess(EnumAcl.enquiriesSwitchCotationStatus)
                          ) {
                          <span
                            class="badge"
                            [class.bg-primary]="
                                line.status === EnumEnquiryCotationStatus.waitingForAnswer
                            "
                            [class.bg-success]="isSuccessfulCotationStatus(line.status)"
                            [class.bg-danger]="line.status === EnumEnquiryCotationStatus.rejected"
                            [class.bg-warning]="line.status === EnumEnquiryCotationStatus.toContact"
                            [class.bg-secondary]="!isKnownCotationStatus(line.status)"
                            [innerText]="getCotationStatusLabel(line.status) | translate"
                          ></span>
                        }
                        @if (
                          enquiry.status !== EnumEnquiryStatus.confirmed &&
                          hasAclAccess(EnumAcl.enquiriesSwitchCotationStatus)
                          ) {
                          <div
                            class="dropdown"
                            >
                            <button
                              type="button"
                              class="btn btn-sm dropdown-toggle"
                                [class.btn-primary]="
                                    line.status === EnumEnquiryCotationStatus.waitingForAnswer
                                "
                                [class.btn-success]="
                                    line.status === EnumEnquiryCotationStatus.answered
                                "
                                [class.btn-danger]="isRejectedCotationStatus(line.status)"
                                [class.btn-warning]="
                                    line.status === EnumEnquiryCotationStatus.toContact
                                "
                              [class.btn-secondary]="!isKnownCotationStatus(line.status)"
                              [attr.id]="'dropdownMenuButton-line-status'"
                              data-bs-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              (click)="openDropdownCotationStatus()"
                              [innerText]="getCotationStatusLabel(line.status) | translate"
                            ></button>
                            <div
                              class="dropdown-menu"
                              [attr.aria-labelledby]="'dropdownMenuButton-line-status'"
                              >
                              @for (status of statusLabelList; track status.value) {
                                <button
                                  type="button"
                                  class="dropdown-item"
                                    [innerText]="
                                        'ENQUIRIES.AIRLINES_QUOTING.CHANGE_STATUS_TO_X'
                                            | translate
                                                : {
                                                      newStatus: status.title | translate
                                                  }
                                    "
                                    (click)="changeLineStatus(line, status.value)"
                                [class.disabled]="line.status === status.value"
                              ></button>
                            }
                          </div>
                        </div>
                      }
                    </td>
                    <td [innerHtml]="line.airlineTitle"></td>
                    <td [innerHtml]="line.airlineCountryTitle"></td>
                    @if (![EnumEnquiryType.acmi].includes(enquiry.type)) {
                      <td>
                        <span [innerHtml]="line.legsTitle"></span>
                        @if (
                          line.legsId &&
                          legsList[line.itineraryId] &&
                          line.legsId.length &&
                          line.legsId.length < legsList[line.itineraryId].length
                          ) {
                          <div
                            >
                            <fa-icon
                              [icon]="faWarning"
                                    [appTooltip]="
                                        'Tous les legs ne sont pas présent sur cette cotation (' +
                                        line.legsId.length +
                                        '/' +
                                        legsList[line.itineraryId].length +
                                        ')'
                                    "
                            ></fa-icon>
                          </div>
                        }
                      </td>
                      <td>
                        {{ line.aircraftTitle?.toUpperCase() }}
                        @if (line.aircraftErrorMessages.length) {
                          <div>
                            <fa-icon
                              [icon]="faWarning"
                              [appTooltip]="line.aircraftErrorMessages.join('<hr>')"
                            ></fa-icon>
                          </div>
                        }
                      </td>
                      <td
                        class="text-center"
                            [innerHtml]="
                                line.ageAverage
                                    ? line.ageAverage + ' ans'
                                    : ('GENERAL.UNKNOWN' | translate)
                            "
                      ></td>
                      @if (
                        ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(
                        enquiry.type
                        )
                        ) {
                        <td
                          class="text-center"
                          [innerHtml]="line.capacityAircraft"
                        ></td>
                      }
                      @if ([EnumEnquiryType.cargo].includes(enquiry.type)) {
                        <td
                          class="text-center"
                          [innerHtml]="line.weightAircraft + ' kg'"
                        ></td>
                      }
                      @if ([EnumEnquiryType.cargo].includes(enquiry.type)) {
                        <td
                          class="text-center"
                          [innerHtml]="line.volumeAircraft + ' m<sup>3</sup>'"
                        ></td>
                      }
                      @if (![EnumEnquiryType.cargo].includes(enquiry.type)) {
                        <td
                          class="text-center"
                          >
                          <span [innerHtml]="line.nbPax"></span>
                          @if (line.nbPax > line.capacityAircraft) {
                            <div>
                              <fa-icon
                                [icon]="faWarning"
                                appTooltip="Il y a plus de passagers que la capacité de l'appareil"
                              ></fa-icon>
                            </div>
                          }
                        </td>
                      }
                    }
                    @if ([EnumEnquiryType.acmi].includes(enquiry.type)) {
                      <td [innerText]="line.acmiAircraftType || ''"></td>
                      <td [innerText]="line.acmiAircraftVersion || ''"></td>
                      <td [innerText]="(line.acmiDateStart | date : 'dd/MM/yyyy') || ''"></td>
                      <td [innerText]="(line.acmiDateEnd | date : 'dd/MM/yyyy') || ''"></td>
                      <td
                        class="text-center"
                            [innerText]="
                                line.acmiBhMinimumPerMonth
                                    ? line.acmiBhMinimumPerMonth +
                                      '/' +
                                      ('GENERAL.MONTH' | translate)
                                    : ''
                            "
                      ></td>
                      <td class="text-center" [innerText]="line.acmiMinimumCycleRatio || ''"></td>
                      <td class="text-center" [innerText]="line.acmiBase || ''"></td>
                      <td class="text-center">
                        @for (airportId of line.acmiRouting; track airportId; let i = $index) {
                          @if (i !== 0) {
                            <span>-</span>
                          }
                          <span [innerText]="airportId"></span>
                        }
                      </td>
                      <td class="text-center" [innerText]="line.acmiNbCrew || ''"></td>
                      <td
                        class="text-center"
                            [innerText]="
                                line.cotationId && line.acmiPerDiemsIncluded
                                    ? ('GENERAL.YES' | translate)
                                    : line.acmiPerDiems || ''
                            "
                      ></td>
                      <td
                        class="text-center"
                            [innerText]="
                                line.cotationId && line.acmiCrewHotacIncluded
                                    ? ('GENERAL.YES' | translate)
                                    : line.acmiCrewHotac || ''
                            "
                      ></td>
                      <td
                        class="text-center"
                            [innerText]="
                                line.cotationId && !line.acmiHasAdditionalInsurance
                                    ? ('GENERAL.NO' | translate)
                                    : line.acmiAdditionalInsurance || ''
                            "
                      ></td>
                      @if (enquiry.acmiType === EnumAcmiType.cargo) {
                        <td
                          class="text-center"
                          [innerText]="line.acmiWeightMax ? line.acmiWeightMax + 'kg' : ''"
                        ></td>
                      }
                      @if (enquiry.acmiType === EnumAcmiType.cargo) {
                        <td
                          class="text-center"
                            [innerHtml]="
                                line.acmiVolumeMax ? line.acmiVolumeMax + 'm<sup>3</sup>' : ''
                            "
                        ></td>
                      }
                    }
                    <td class="text-end">
                      <div>
                        {{
                        line.buyingPriceInCurrency !== null
                        ? formatPrice(line.buyingPriceInCurrency, line.currency)
                        : ""
                        }}
                      </div>
                      @if (line.currency !== defaultCurrency) {
                        <div>
                          {{
                          line.buyingPrice !== null
                          ? "= " + formatPrice(line.buyingPrice, defaultCurrency)
                          : ""
                          }}
                        </div>
                      }
                      @if (line.isNationalFlight && line.buyingPrice) {
                        <div>
                          <fa-icon
                            [icon]="faWarning"
                            appTooltip="Attention: les prix sont avec TVA car c'est un vol national"
                          ></fa-icon>
                        </div>
                      }
                    </td>
                    @if (
                      ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)
                      ) {
                      <td
                        class="text-end"
                        >
                        @if (line.taxesByPersonIncluded) {
                          <div>{{ 'ENQUIRIES.AIRLINES_QUOTING.INCLUDED' | translate }}</div>
                        } @else {
                          <div>
                            {{
                            line.taxesTotalPaxInCurrency !== null
                            ? formatPrice(line.taxesTotalPaxInCurrency, line.currency)
                            : ""
                            }}
                          </div>
                          @if (line.currency !== defaultCurrency) {
                            <div>
                              {{
                              line.taxesTotalPax !== null
                              ? "= " + formatPrice(line.taxesTotalPax, defaultCurrency)
                              : ""
                              }}
                            </div>
                          }
                        }
                      </td>
                    }
                    @if (
                      ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)
                      ) {
                      <td
                        class="text-end"
                        >
                        @if (line.cateringByPersonIncluded) {
                          <div>{{ 'ENQUIRIES.AIRLINES_QUOTING.INCLUDED' | translate }}</div>
                        } @else {
                          <div>
                            {{
                            line.cateringInCurrency !== null
                            ? formatPrice(line.cateringInCurrency, line.currency)
                            : ""
                            }}
                          </div>
                          @if (line.currency !== defaultCurrency) {
                            <div>
                              {{
                              line.catering !== null
                              ? "= " + formatPrice(line.catering, defaultCurrency)
                              : ""
                              }}
                            </div>
                          }
                        }
                      </td>
                    }
                    <td class="text-end">
                      <div>
                        {{
                        line.priceNetTTCInCurrency !== null
                        ? formatPrice(line.priceNetTTCInCurrency, line.currency)
                        : ""
                        }}
                      </div>
                      @if (line.currency !== defaultCurrency) {
                        <div>
                          {{
                          line.priceNetTTC !== null
                          ? "= " + formatPrice(line.priceNetTTC, defaultCurrency)
                          : ""
                          }}
                        </div>
                      }
                      @if (line.isNationalFlight && line.priceNetTTC) {
                        <div>
                          <fa-icon
                            [icon]="faWarning"
                            appTooltip="Attention: les prix sont avec TVA car c'est un vol national"
                          ></fa-icon>
                        </div>
                      }
                    </td>
                    @if (
                      ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)
                      ) {
                      <td
                        class="text-end"
                        >
                        <div>
                          {{
                          line.pricePPInCurrency !== null
                          ? formatPrice(line.pricePPInCurrency, line.currency)
                          : ""
                          }}
                        </div>
                        @if (line.currency !== defaultCurrency) {
                          <div>
                            {{
                            line.pricePP !== null
                            ? "= " + formatPrice(line.pricePP, defaultCurrency)
                            : ""
                            }}
                          </div>
                        }
                      </td>
                    }
                    <td class="text-end">
                      <div>
                        {{
                        line.sellingPriceInCurrency !== null
                        ? formatPrice(line.sellingPriceInCurrency, line.currency)
                        : ""
                        }}
                      </div>
                      @if (line.currency !== defaultCurrency) {
                        <div>
                          {{
                          line.sellingPrice !== null
                          ? "= " + formatPrice(line.sellingPrice, defaultCurrency)
                          : ""
                          }}
                        </div>
                      }
                      @if (line.isNationalFlight && line.sellingPrice) {
                        <div>
                          <fa-icon
                            [icon]="faWarning"
                            appTooltip="Attention: les prix sont avec TVA car c'est un vol national"
                          ></fa-icon>
                        </div>
                      }
                    </td>
                    <td class="text-end">
                      <div>
                        {{
                        line.marginInCurrency !== null
                        ? formatPrice(line.marginInCurrency, line.currency)
                        : ""
                        }}
                      </div>
                      @if (line.currency !== defaultCurrency) {
                        <div>
                          {{
                          line.margin !== null
                          ? "= " + formatPrice(line.margin, defaultCurrency)
                          : ""
                          }}
                        </div>
                      }
                      @if (line.marginOnConfirmed && line.marginOnConfirmed !== line.margin) {
                        <em
                            [innerText]="
                                'Marge à la confirmation : ' +
                                formatPrice(line.marginOnConfirmed, defaultCurrency)
                            "
                        ></em>
                      }
                    </td>
                    <td class="text-end">
                      <div>
                        {{
                        line.marginPercentInCurrency !== null
                        ? line.marginPercentInCurrency
                        : ""
                        }}
                      </div>
                      @if (line.currency !== defaultCurrency) {
                        <div>
                          {{ line.marginPercent !== null ? "= " + line.marginPercent + "%" : "" }}
                        </div>
                      }
                    </td>
                    @if (
                      ![EnumEnquiryType.cargo, EnumEnquiryType.acmi].includes(enquiry.type)
                      ) {
                      <td
                        class="text-end"
                        >
                        <div>
                          {{
                          line.sellingPricePPInCurrency !== null
                          ? formatPrice(line.sellingPricePPInCurrency, line.currency)
                          : ""
                          }}
                        </div>
                        @if (line.currency !== defaultCurrency) {
                          <div>
                            {{
                            line.sellingPricePP !== null
                            ? "= " + formatPrice(line.sellingPricePP, defaultCurrency)
                            : ""
                            }}
                          </div>
                        }
                      </td>
                    }
                    <td [innerHtml]="line.notes"></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <div class="modal" tabindex="-1" role="dialog" #modalCotationEdit>
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <app-enquiry-cotation-edit-modal-content
              [form]="form"
              [enquiry]="enquiry"
              [currentOffer]="currentOffer"
              [currentCotation]="currentCotation"
              [airlinesAircrafts]="airlinesAircrafts"
              [itinerariesList]="itinerariesList"
              [legsList]="legsList"
              [legsObj]="legsObj"
              [airportsObj]="airportsObj"
              [defaultCurrency]="defaultCurrency"
              [todayCurrencyExchangeRate]="todayCurrencyExchangeRate"
              [EnumEnquiryType]="EnumEnquiryType"
              [EnumAcmiType]="EnumAcmiType"
              [getCountryLabel]="getCountryLabel"
              [getDefaultCurrency]="getDefaultCurrency"
              [getCurrencies]="getCurrencies.bind(this)"
              [getEnumCurrencySymbol]="getEnumCurrencySymbol"
              [getEnumCurrencyLabel]="getEnumCurrencyLabel"
              [saveCotation]="saveCotation.bind(this)"
              [updateItineraryIdOfCotation]="updateItineraryIdOfCotation.bind(this)"
              [updateLegsId]="updateLegsId.bind(this)"
              [updatedCurrency]="updatedCurrency.bind(this)"
              [updatedValue]="updatedValue.bind(this)"
              [updateTaxesByPersonType]="updateTaxesByPersonType.bind(this)"
              [updatedTaxesByPersonByLeg]="updatedTaxesByPersonByLeg.bind(this)"
              [updatedTaxesByPersonByAirport]="updatedTaxesByPersonByAirport.bind(this)"
              [updateByPersonIncludedField]="updateByPersonIncludedField.bind(this)"
              [setValueToFormControl]="setValueToFormControl.bind(this)"
              [removeAcmiRouting]="removeAcmiRouting.bind(this)"
              [acmiDatesInMonth]="acmiDatesInMonth.bind(this)"
            ></app-enquiry-cotation-edit-modal-content>
          </div>
        </div>
      </div>

      <div class="modal" tabindex="-1" role="dialog" #modalCotationAttachedDocuments>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Documents attachés à la cotation</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                [attr.aria-label]="'GENERAL.CLOSE' | translate"
              ></button>
            </div>
            <ul class="list-group list-group-flush">
              @if (!currentCotation?.attachedDocuments?.length) {
                <li
                  class="list-group-item list-group-item-warning text-center"
                  >
                  Aucun document attaché à cette cotation.
                </li>
              }
              @if (currentCotation?.attachedDocuments?.length) {
                @for (
                  attachedDocument of currentCotation?.attachedDocuments; track
                  attachedDocument; let i = $index) {
                  <li
                    class="list-group-item"
                    >
                    <div class="row align-items-center">
                      <div class="col-9">
                        <a [href]="attachedDocument.url" target="_blank"
                          >{{ attachedDocument.name }}
                          <fa-icon [icon]="faExternalLink"></fa-icon></a
                          ><br />
                          {{ formatBytes(attachedDocument.size) }} {{ attachedDocument.type }}
                        </div>
                        @if (
                          hasAclAccess(EnumAcl.enquiriesEditAttachedDocumentsToCotation)
                          ) {
                          <div
                            class="col-3 text-end"
                            >
                            <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              (click)="deleteAttachedDocument(i)"
                              >
                              <fa-icon [icon]="faTrash"></fa-icon>
                            </button>
                          </div>
                        }
                      </div>
                    </li>
                  }
                }
              </ul>
              @if (hasAclAccess(EnumAcl.enquiriesEditAttachedDocumentsToCotation)) {
                <div class="p-3">
                  <app-file-input #inputFile labelKey="GENERAL.FILE_INPUT.DOCUMENT"
                    [busy]="uploadingAttachedDocument"
                    (fileSelected)="changeInputFile($event)"></app-file-input>
                </div>
              }
            </div>
          </div>
        </div>
